const isSubsequence = (query: string, name: string): boolean => {
  let nameIndex = 0
  for (const character of query) {
    nameIndex = name.indexOf(character, nameIndex)
    if (nameIndex === -1) return false
    nameIndex += 1
  }
  return true
}

export function fuzzyMatch<T extends { name: string; count: number }>(
  query: string,
  candidates: T[],
): T[] {
  const normalizedQuery = query.trim().toLowerCase()
  if (normalizedQuery === '') return [...candidates]

  return candidates
    .map((candidate, originalIndex) => ({
      candidate,
      originalIndex,
      normalizedName: candidate.name.toLowerCase(),
    }))
    .filter(({ normalizedName }) =>
      isSubsequence(normalizedQuery, normalizedName),
    )
    .sort((left, right) => {
      const leftPrefix = left.normalizedName.startsWith(normalizedQuery)
      const rightPrefix = right.normalizedName.startsWith(normalizedQuery)
      if (leftPrefix !== rightPrefix) return leftPrefix ? -1 : 1
      if (left.normalizedName < right.normalizedName) return -1
      if (left.normalizedName > right.normalizedName) return 1
      return left.originalIndex - right.originalIndex
    })
    .map(({ candidate }) => candidate)
}
